import { render } from "./SingleSymbolPNG.vue?vue&type=template&id=1dbca4f0"
import script from "./SingleSymbolPNG.vue?vue&type=script&lang=js"
export * from "./SingleSymbolPNG.vue?vue&type=script&lang=js"

import "./SingleSymbolPNG.vue?vue&type=style&index=0&id=1dbca4f0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__